import { useDispatch, useSelector } from 'react-redux';
import { formatDateWithoutZulu, formatPrice, getShortDate } from 'utils/utils';

import { ReactComponent as ChevronRightIcon } from 'assett/icons/chevron_right_icon.svg';
import { setSelectOne } from 'feature/payments/paymentsSlice';
import { useNavigate } from 'react-router-dom';
import { AppDispatch, RootState } from 'store/store';
import { TableBody, TableCell, TableRow } from 'styles';
import IconButton from 'styles/button/IconButton';
import Checkbox from 'styles/checkbox/Checkbox';
import Typography from 'styles/typography/Typograpy';
import { IPayments } from 'types/Payments';
import { PATHNAMES } from 'utils/constants';
import { useTranslation } from 'utils/translations';

export const PaymentsBody = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { payments, paymentsIds } = useSelector(
		(store: RootState) => store.payments,
	);
	const navigate = useNavigate();

	const handleClick = (payment: IPayments) => {
		navigate(
			`/${PATHNAMES.VIEW_PAYMENT_HISTORY}/${
				payment.paymentRunId
			}|${formatDateWithoutZulu(payment.paymentRunDate)}`,
		);
	};

	const List = payments.map((payment: IPayments) => {
		return (
			<TableRow key={payment.paymentRunId + payment.paymentRunDate}>
				<TableCell sx={{ width: 220 }}>
					<Checkbox
						label=""
						accessibilitylabel={`${tClientLabels('payment.labels.selectPayment')}`}
						key={payment.paymentRunId}
						sx={{ p: 0, ml: 0 }}
						checked={paymentsIds.includes(
							payment.paymentRunId + payment.paymentRunDate,
						)}
						onClick={() =>
							dispatch(setSelectOne(payment.paymentRunId + payment.paymentRunDate))
						}
					/>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">
						{getShortDate(payment.paymentRunDate)}
					</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">{`#${payment.paymentRunId}`}</Typography>
				</TableCell>
				<TableCell sx={{ width: 220 }}>
					<Typography variant="body">{formatPrice(payment.totalAmount)}</Typography>
				</TableCell>
				<TableCell>
					<IconButton
						onClick={() => handleClick(payment)}
						sx={{ cursor: 'pointer' }}
						aria-label={`${tClientLabels('payment.labels.viewDetails')}`}
					>
						<ChevronRightIcon />
					</IconButton>
				</TableCell>
			</TableRow>
		);
	});

	const progressIndicator = useSelector(
		(state: RootState) => state.progressIndicator,
	);

	return List.length > 0 ? (
		<TableBody>{List}</TableBody>
	) : List && !progressIndicator?.isLoading ? (
		<TableBody
			sx={{
				'& td': {
					paddingLeft: '0px!important',
					textAlign: 'left!important',
					backgroundColor: 'transparent!important',
				},
			}}
		>
			<TableRow>
				<TableCell colSpan={12}>
					<Typography variant="bodyLink" sx={{ width: '100%' }}>
						{tClientLabels('view-payment-history.noPaymentsFound')}
					</Typography>
				</TableCell>
			</TableRow>
		</TableBody>
	) : null;
};

export default PaymentsBody;
